<template>
  <div class="vue-user-profile-wrap">
    <div>
      <b-modal
      hide-footer
      @hide="cancel"
      id="user-profile-modal"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>User Profile</h3>
          <div class="status-messages">
            <span
            v-if="changePasswordSuccess"
            class="status-message success"
            v-bind:class="{fade: changePasswordSuccessFade}">Password successfully changed</span>
            <span
            v-if="changePasswordError"
            class="status-message error"
            v-bind:class="{fade: changePasswordErrorFade}">{{changePasswordError}}</span>
          </div>
        </template>
        <div
        class="modal-body-container"
        v-bind:class="{isMobile: isMobile() || isTablet()}">
          <div class="modal-body">
            <div class="menu">
              <ul class="menu-items">
                <li
                class="menu-item"
                v-on:click="showDefaultWorkflow"
                title="Manage Utilities"
                v-bind:class="{selected: workflow === 'default'}">Overview</li>
                <li
                class="menu-item"
                v-on:click="showCangePasswordWorkflow"
                title="Manage Towns"
                v-bind:class="{selected: workflow === 'change-password'}">Change Password</li>
              </ul>
            </div>
            <div class="content">
              <div v-if="workflow === 'default'" class="profile-info-container">
                <div class="profile-info">
                  <ul class="profile-items">
                  <li class="profile-item"><span class="key">Username:</span><span class="val">{{user.username}}</span></li>
                  <li class="profile-item"><span class="key">Email:</span><span class="val">{{user.attributes.email}}</span></li>
                  <li class="profile-item"><span class="key">Phone:</span><span class="val">{{user.attributes.phone_number}}</span></li>
                  </ul>
                </div>
              <div v-if="userGroups && userGroups.length" class="groups-container">
                <p class="groups-header">Groups:</p>
                <ul class="groups">
                  <li v-for="userGroup in userGroups" :key="userGroup.name" class="group">
                  {{ userGroup.name }}
                  </li>
                </ul>
              </div>
              </div>
              <change-password-form
              v-if="workflow ===  'change-password'"
              :showDefaultWorkflow="showDefaultWorkflow"
              :passwordChangeSuccess="onPasswordChangeSuccess"
              :passwordChangeError="onPasswordChangeError"></change-password-form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import Vue from 'vue';
import vueMqMixin from "../../../shared/mixins/VueMqMixin";
import ChangePasswordForm from "./ChangePasswordForm";

export default {
  name: 'UserProfileModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    hideModal: Function
  },
  components: {
    ChangePasswordForm
  },
  data() {
    return {
      changePasswordSuccess: undefined,
      changePasswordError: undefined,
      changePasswordSuccessFade: undefined,
      changePasswordErrorFade: undefined,
      credentials: {},
      myclass: [],
      workflow: 'default',
      userGroups: []
    }
  },
  async created() {
    Vue.nextTick(() => this.$bvModal.show('user-profile-modal'));
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal user-profile isMobileOrTablet'] : ['vt-outages-modal user-profile'];
  
    const userGroups =   this.user.signInUserSession.accessToken.payload["cognito:groups"];

    if (userGroups) {
      userGroups.forEach(userGroup => {
        this.userGroups.push({
          name: userGroup
        });
      });
    }
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      showDefaultWorkflow() {
        this.workflow = 'default';
      },
      showCangePasswordWorkflow() {
        this.workflow = 'change-password';
      },
      onPasswordChangeSuccess() {
        this.changePasswordSuccess = true;
        this.credentials = {};
        this.showDefaultWorkflow();
        setTimeout(() => {this.changePasswordSuccessFade = true}, 5000);
        setTimeout(() => {
          this.changePasswordSuccess = undefined;
          this.changePasswordSuccessFade = undefined;
        }, 10000);
      },
      onPasswordChangeError(err) {
            this.changePasswordError = err.message ? err.message : 'There was an error changing your password.';
            setTimeout(() => {this.changePasswordErrorFade = true}, 5000);
            setTimeout(() => {
              this.changePasswordError = undefined;
              this.changePasswordErrorFade = undefined;
            }, 10000);
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/partials/_variables.scss";

.modal-body-container{
  .modal-body{
    .menu{
      .menu-items{
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: start;

        .menu-item{
            list-style-type: none;
            width: 20%;
            height: 50px;
            margin: 0 20px 0 0;
            padding: 5px;
            font-weight: 500;
            line-height: 50px;
            color: #fff;
            background-color: $navy;
            text-align: center;

          &:last-child{
            margin-right: 0;
          }

          &:hover{
            cursor: pointer;
            color: #fff;
            background-color: $tealDark;
          }

          &.selected{
            color: $black;
            background-color: $lightGrey;
          }
        }
      }
    }

    .content{
      padding:  20px 50px 50px 50px;
      background-color: $lightGrey;

      .profile-info-container{
        .profile-info{
          .profile-items{
            .profile-item{
              .key{
                margin-right: 10px;
                font-weight: $xbold;
              }
            }
          }
        }

        .groups-container{
          .groups-header{
            font-weight: $xbold;
          }

          .groups{
            .group{
              display: inline-block;
              width: 31%;
              margin-right: 1%;
              padding: 5px;
              background-color: #fff;
            }
          }
        }
      }
    }
  }

  &.isMobile{
    .modal-body{
      .menu{
        .menu-items{
          .menu-item{
              width: 40%;
          }
        }
      }

      .content{
        padding:  10px;
        background-color: $lightGrey;

        .profile-info-container{
          .profile-info{
            .profile-items{
              .profile-item{
                .key{
                  margin-right: 10px;
                  font-weight: $xbold;
                }
              }
            }
          }

          .groups-container{
            .groups-header{
              font-weight: $xbold;
            }

            .groups{
              .group{
                display: inline-block;
                width: 31%;
                margin-right: 1%;
                padding: 5px;
                background-color: #fff;
              }
            }
          }
        }
      }
    } 
  }
}
</style>
